<template>
  <div class="w-100">
    <b-radio-group stacked v-model="selectAllChecked" @change="handleCheckboxChange">
      <b-radio :value="true">
        <span :class="{ 'text-muted': !selectAllChecked }">{{ selectAllText }}</span>
      </b-radio>
      <b-radio :value="false">
        <span :class="{ 'text-muted': selectAllChecked }">{{ placeholder }}</span>
      </b-radio>
    </b-radio-group>

    <div class="selector w-100" :class="{ 'semi-transparent': selectAllChecked }">
      <div class="selectorOverlay" v-if="selectAllChecked"></div>
      <search-dropdown value="" @input="addValue" :options="availableOptions" />
      <div class="mt-2 valueHolder">
        <b-btn class="button valueButton py-0 m-1" size="sm" variant="light-muted" v-for="(val, index) in displayedValues" :key="index">
          {{ val }}
          <span class="h6 align-middle pl-2 font-weight-bold item-remove" @click="removeValue(index)">
            &times;
          </span>
        </b-btn>
      </div>

      <div v-if="collapsedValues > 0" class="collapser noselect" @click="collapsed = !collapsed">
        <div class="text-center mt-4">
          <template v-if="!collapsed">
            <cool-label class="mb-1 text-medium d-block">Hide {{ collapsedValues }} selected {{ valueNamePlural }}</cool-label>
            <span class="icon h3 icon-Table_Arrow_Close text-medium mt-1 mb-0" />
          </template>
          <template v-else>
            <cool-label class="mb-1 text-medium d-block">View {{ collapsedValues }} more selected {{ valueNamePlural }}</cool-label>
            <span class="icon h3 icon-Table_Arrow_Open text-medium mt-1 mb-0" />
          </template>
        </div>
        <hr class="m-0 border-border" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.selectorOverlay {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1000
}
.selector {
  position: relative;
}
.semi-transparent {
  opacity: 0.5
}
.button {
  font-weight: 500;
}
</style>

<script>
import SearchDropdown from '@/components/SearchDropdown'
import _ from 'lodash'

export default {
  props: {
    /**
     * nothing inherently requires options to be an array
     * if you need it to be an object, you can 
     * change this component to make that happen
     */
    options: { required: true, type: Array },
    values: { required: true, type: Array },
    selectAllText: { required: false, type: String, default: 'Select all' },
    placeholder: { required: false, type: String, default: 'Select value(s)' },
    valueNamePlural: { required: false, type: String, default: 'values'},
  },
  data () {
    return {
      collapsedValueNum: 25, //how many values to show when collapsed
      collapsed: true,
      selectAllChecked: true, //whether 'select all' is checked
      internalValues: [], //list of user-selected values that holds steady, even when 'select all' is checked
      initialized: false
    }
  },
  methods: {
    handleRadioInput (checked) {
      console.log(checked)
    },
    selectAll () {
      for (let option of this.options) {
        if (!this.values.includes(option)) {
          this.values.push(option)
        }
      }
    },
    handleCheckboxChange (checked) {
      if (checked === true) {
        this.selectAll()
      } else {
        this.setValuesToInternal()
      }
    },
    removeValue (index) {
      this.values.splice(index, 1)
    },
    addValue (value) {
      this.values.push(value)
    },
    setValuesToInternal () {
      while (this.values.length > 0) {
        this.values.pop()
      }
      for (let value of this.internalValues) {
        this.values.push(value)
      }
    },
    setInternalToValues () {
      this.internalValues = this.values.slice()
      if (this.allSelected) {
        this.selectAllChecked = true
      } else {
        this.selectAllChecked = false
      }
    },
    /**
     * adjust the radio button, if necessary, 
     * to reflect proper initial state of component
     */
    initialize () {
      if (!this.initialized) {
        if (this.options !== undefined && this.options.length > 0 && this.values !== undefined) {
          this.initialized = true
          this.selectAllChecked = this.allSelected
        }
      }
    }
  },
  computed: {
    collapsedValues () {
      return Math.max(0, this.internalValues.length - this.collapsedValueNum)
    },
    displayedValues () {
      if (this.collapsed) {
        return this.internalValues.slice(0, this.collapsedValueNum)
      } else {
        return this.internalValues
      }
    },
    availableOptions () {
      return _.difference(this.options, this.internalValues)
    },
    allSelected () {
      for (let option of this.options) {
        if (!this.values.includes(option)) {
          return false
        }
      }
      return true
    }
  },
  watch: {
    values () {
      if (this.values !== undefined) {
        this.setInternalToValues()
      }
      this.initialize()
    },
    options () {
      this.initialize()
    }
  },
  components: {
    SearchDropdown
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ManySelector.vue